import React from "react";
import { Select } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import useDrawerStyles from "../style";

// Mantine's Select requires string data values — this sentinel stands in for
// options whose real value is null (e.g. the Facility picker's "All
// facilities"), and is converted back to null before onSelect fires.
const NULL_KEY = "__null__";
const toKey = (v) => (v === null || v === undefined ? NULL_KEY : String(v));

// Generic dropdown (Provider select, Facility select, Signer select) — backed
// by Mantine's own Select using its default option rendering (no custom
// itemComponent); any per-option meta text (e.g. "no signature on file") is
// folded into the label itself since Mantine's default item is plain text.
const DropdownSelect = ({ value, options, getLabel = (o) => o.label, getMeta, onSelect, placeholder }) => {
  const { classes } = useDrawerStyles();

  const data = options.map((opt) => {
    const meta = getMeta?.(opt);
    return {
      value: toKey(opt.value),
      label: meta ? `${getLabel(opt)} · ${meta}` : getLabel(opt),
    };
  });

  // Only show a value as "selected" if it actually matches a real option —
  // otherwise fall back to null so Mantine renders the placeholder, same as
  // the old `options.find(...)` miss behavior.
  const selectedKey = options.some((o) => toKey(o.value) === toKey(value)) ? toKey(value) : null;

  const handleChange = (key) => {
    if (key == null) return;
    const opt = options.find((o) => toKey(o.value) === key);
    if (opt) onSelect(opt);
  };

  return (
    <Select
      data={data}
      value={selectedKey}
      onChange={handleChange}
      placeholder={placeholder}
      rightSection={<IconChevronDown size={15} color="#9CA3AF" />}
      withinPortal
      zIndex={1200}
      maxDropdownHeight={320}
      classNames={{ input: classes.select, dropdown: classes.ddPop, item: classes.ddOpt }}
      styles={{ rightSection: { pointerEvents: "none" } }}
    />
  );
};

export default DropdownSelect;
